"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MoveTo = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M15.5,4 C16.327,4 17,4.673 17,5.5 L17,5.5 L17,7.981 L16,7.981 L16,5.5 C16,5.225 15.776,5 15.5,5 L15.5,5 L4.5,5 C4.224,5 4,5.225 4,5.5 L4,5.5 L4,17.5 C4,17.775 4.224,18 4.5,18 L4.5,18 L15.5,18 C15.776,18 16,17.775 16,17.5 L16,17.5 L16,15.022 L17,15.022 L17,17.5 C17,18.327 16.327,19 15.5,19 L15.5,19 L4.5,19 C3.673,19 3,18.327 3,17.5 L3,17.5 L3,5.5 C3,4.673 3.673,4 4.5,4 L4.5,4 Z M18.6938,8.1895 L22.0048,11.5005 L18.6938,14.8105 L17.9868,14.1035 L20.0898,12.0005 L9.9998,12.0005 L9.9998,11.0005 L20.0898,11.0005 L17.9868,8.8965 L18.6938,8.1895 Z", fillRule: "evenodd" })));
};
MoveTo.displayName = 'MoveTo';
exports.default = MoveTo;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MoveTo.js.map